import RendorRoutes from "./routes";

function App() {
  return <RendorRoutes />;
}

export default App;
